import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ActionButtonOption } from '../group-info/study-group-info';
import { IBreadcrumb, BreadcrumbService } from '../shared/breadcrumb-service/breadcrumb.service';
import { UrlBuilder } from '../../core';
import { FiltersStorage } from '../../covance-filter/filters-storage';

@Component({
    selector: 'sample-tracking-dashboard',
    template: require('./sample-tracking-dashboard.component.html'),
    styles: [require('./sample-tracking-dashboard.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingDashboardComponent implements OnDestroy {

    public actionButtonOption: ActionButtonOption = { text: 'Select Grouping', isRouteToDashboard: true };
    public searchList: { id: number, value: string }[] = [
        { id: 1, value: 'Search by Accession' },
        { id: 2, value: 'Search by Sample' },
    ];
    constructor(
        private urlbuilder: UrlBuilder,
        private breadcrumbService: BreadcrumbService,
        private filterStorage: FiltersStorage,
    ) {
        this.alignBreadcrumb('66px');
        this.filterStorage.isLoaded.subscribe(() => { });
        this.breadcrumbService.clear();
        let portfolioRoute: IBreadcrumb = {
            label: 'Sample Tracking Portfolio',
            url: this.urlbuilder.esa().sampletracking().home().url() as string[]
        };
        this.breadcrumbService.AddRouterToBreadCrumb(portfolioRoute);
    }

    public ngOnDestroy() {
        this.alignBreadcrumb('unset');
    }

    private alignBreadcrumb(position: string) {
        const breadcrumb = document.getElementById('app-breadcrumb');

        if (breadcrumb != null) {
            breadcrumb.style.top = position;
        }
    }
}